import * as Yup from 'yup';
import {
  REQUIRED_FIELD_ERROR2,
  TOTAL_INFO_ERROR,
} from '../../../../utils/constants';

const useFeedValidationSchema = () => {
  const validationSchema = Yup.object().shape({
    isRequired: Yup.boolean(),
    has_breakfast: Yup.boolean(),
    has_lunch: Yup.boolean(),
    has_dinner: Yup.boolean(),
    breakfast: Yup.string()
      .default('')
      .when('has_breakfast', {
        is: (has_breakfast: boolean) => has_breakfast === true,
        then: (validationSchema) =>
          validationSchema
            .max(8, TOTAL_INFO_ERROR)
            .required(REQUIRED_FIELD_ERROR2)
            .test(
              'is-summ-valid',
              'Сумма должна быть больше 0',
              function (breakfast) {
                return Number(breakfast) > 0;
              },
            ),
        otherwise: (validationSchema) =>
          validationSchema.nullable().default(''),
      }),

    lunch: Yup.string()
      .default('')
      .when('has_lunch', {
        is: (has_lunch: boolean) => has_lunch === true,
        then: (validationSchema) =>
          validationSchema
            .max(8, TOTAL_INFO_ERROR)
            .required(REQUIRED_FIELD_ERROR2)
            .test(
              'is-summ-valid',
              'Сумма должна быть больше 0',
              function (lunch) {
                return Number(lunch) > 0;
              },
            ),
        otherwise: (validationSchema) =>
          validationSchema.nullable().default(''),
      }),
    dinner: Yup.string()
      .default('')
      .when('has_dinner', {
        is: (has_dinner: boolean) => has_dinner === true,
        then: (validationSchema) =>
          validationSchema
            .max(8, TOTAL_INFO_ERROR)
            .required(REQUIRED_FIELD_ERROR2)
            .test(
              'is-summ-valid',
              'Сумма должна быть больше 0',
              function (dinner) {
                return Number(dinner) > 0;
              },
            ),
        otherwise: (validationSchema) =>
          validationSchema.nullable().default(''),
      }),

    has_kidsPrice: Yup.boolean(),
    ageKidsFree: Yup.string().max(2, TOTAL_INFO_ERROR),

    kids: Yup.array().of(
      Yup.object().shape({
        start_age: Yup.number().required(REQUIRED_FIELD_ERROR2),
        end_age: Yup.number()
          .transform((value, originalValue) => {
            return originalValue ? Number(originalValue) : null;
          })
          .required(REQUIRED_FIELD_ERROR2)
          .min(1, 'Неверное значение')
          .test('is-kidsAge-valid', 'Неверное значение', function (end_age) {
            const { start_age } = this.parent;
            if (start_age && end_age) {
              return Number(end_age) > Number(start_age);
            }
            return true;
          }),

        kids_breakfast: Yup.string()
          .default('')
          .test(
            'is-kidsBreakfast-valid',
            REQUIRED_FIELD_ERROR2,
            function (kids_breakfast) {
              const has_breakfast = this.options.context?.has_breakfast;
              if (has_breakfast) {
                return has_breakfast && kids_breakfast;
              }
              return true;
            },
          )
          .test(
            'is-summ-valid',
            'Сумма должна быть больше 0',
            function (kids_breakfast) {
              const has_feeding = this.options.context?.has_breakfast;
              if (has_feeding) {
                return Number(kids_breakfast) > 0;
              }
              return true;
            },
          )
          .nullable(),

        kids_lunch: Yup.string()
          .default('')
          .test(
            'is-kidsLunch-valid',
            REQUIRED_FIELD_ERROR2,
            function (kids_lunch) {
              const has_feeding = this.options.context?.has_lunch;
              if (has_feeding) {
                return has_feeding && kids_lunch;
              }
              return true;
            },
          )
          .test(
            'is-summ-valid',
            'Сумма должна быть больше 0',
            function (kids_lunch) {
              const has_feeding = this.options.context?.has_lunch;
              // console.log(has_feeding)
              if (has_feeding) {
                return Number(kids_lunch) > 0;
              }
              return true;
            },
          )
          .nullable(),

        kids_dinner: Yup.string()
          .default('')
          .test(
            'is-kidsDinner-valid',
            REQUIRED_FIELD_ERROR2,
            function (kids_dinner) {
              const has_feeding = this.options.context?.has_dinner;
              if (has_feeding) {
                return has_feeding && kids_dinner;
              }
              return true;
            },
          )
          .test(
            'is-summ-valid',
            'Сумма должна быть больше 0',
            function (kids_dinner) {
              const has_feeding = this.options.context?.has_dinner;
              if (has_feeding) {
                // console.log(Number(kids_dinner) > 0);
                return Number(kids_dinner) > 0;
              }
              return true;
            },
          )
          .nullable(),
      }),
    ),
  });
  return validationSchema;
};
export default useFeedValidationSchema;
